import React, { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = "https://admin.shopaholics.ge/api";

const GiftCardAdd = () => {
  const [imageFile, setImageFile] = useState(null);
  const [amount, setAmount] = useState("");
  const [price, setPrice] = useState("");
  const [active, setActive] = useState(true);
  const [giftCards, setGiftCards] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // Fetch gift cards on page load
  useEffect(() => {
    fetchGiftCards();
  }, []);

  const fetchGiftCards = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/get_gift_cards.php`);
      if (response.data.success) {
        setGiftCards(response.data.gift_cards);
      } else {
        console.error("❌ Failed to fetch gift cards:", response.data.error);
      }
    } catch (err) {
      console.error("❌ Error fetching gift cards:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if ((!imageFile && !editingId) || !amount || !price) {
      setError("❌ Please fill in all fields and upload an image!");
      setMessage("");
      return;
    }

    const formData = new FormData();
    if (imageFile) formData.append("image", imageFile); // Optional in edit
    formData.append("amount", amount);
    formData.append("price", price);
    formData.append("active", active ? 1 : 0);
    if (editingId) formData.append("id", editingId);

    try {
      const url = editingId
        ? `${API_BASE_URL}/update_gift_card.php`
        : `${API_BASE_URL}/add_gift_cards.php`;

      const response = await axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success) {
        setMessage(`✅ Gift card ${editingId ? "updated" : "added"} successfully!`);
        setError("");
        resetForm();
        fetchGiftCards(); // Refresh list
      } else {
        setError(`❌ ${response.data.error}`);
        setMessage("");
      }
    } catch (err) {
      console.error("❌ Error:", err);
      setError("❌ Failed to process request.");
    }
  };

  const resetForm = () => {
    setImageFile(null);
    setAmount("");
    setPrice("");
    setActive(true);
    setEditingId(null);
  };

  const handleEdit = (giftCard) => {
    setEditingId(giftCard.id);
    setAmount(giftCard.amount);
    setPrice(giftCard.price);
    setActive(giftCard.active === "1");
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this gift card?")) return;

    try {
      const response = await axios.post(`${API_BASE_URL}/delete_gift_card.php`, { id });
      if (response.data.success) {
        setMessage("✅ Gift card deleted successfully!");
        fetchGiftCards(); // Refresh list
      } else {
        setError(`❌ ${response.data.error}`);
      }
    } catch (err) {
      console.error("❌ Error deleting gift card:", err);
      setError("❌ Failed to delete gift card.");
    }
  };

  return (
    <div style={{ maxWidth: "700px", margin: "auto", padding: "20px" }}>
      <h2>{editingId ? "Edit Gift Card" : "Add New Gift Card"}</h2>

      {message && <p style={{ color: "green" }}>{message}</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}

      <form onSubmit={handleSubmit} style={{ marginBottom: "30px" }}>
        <div style={{ marginBottom: "15px" }}>
          <label>Upload Image:</label>
          <input
            type="file"
            onChange={(e) => setImageFile(e.target.files[0])}
            accept="image/*"
            style={{ width: "100%", padding: "8px", marginTop: "5px" }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label>Gift Card Amount:</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter Amount"
            style={{ width: "100%", padding: "8px" }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label>Price to Buy:</label>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="Enter Price"
            style={{ width: "100%", padding: "8px" }}
          />
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label>
            <input
              type="checkbox"
              checked={active}
              onChange={(e) => setActive(e.target.checked)}
              style={{ marginRight: "8px" }}
            />
            Active
          </label>
        </div>

        <button
          type="submit"
          style={{
            padding: "10px 20px",
            backgroundColor: "#333",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          {editingId ? "Update Gift Card" : "Add Gift Card"}
        </button>
        {editingId && (
          <button
            type="button"
            onClick={resetForm}
            style={{
              padding: "10px 20px",
              backgroundColor: "#888",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              marginLeft: "10px",
            }}
          >
            Cancel
          </button>
        )}
      </form>

      <h3>Gift Cards List</h3>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Image</th>
            <th>Amount</th>
            <th>Price</th>
            <th>Active</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {giftCards.map((card) => (
            <tr key={card.id} style={{ borderBottom: "1px solid #ddd" }}>
              <td>
                <img src={`https://admin.shopaholics.ge/api/${card.image}`} alt="Gift" width="80" />
              </td>
              <td>{card.amount}</td>
              <td>{card.price}</td>
              <td>{card.active === "1" ? "Yes" : "No"}</td>
              <td>
                <button onClick={() => handleEdit(card)} style={{ marginRight: "10px" }}>Edit</button>
                <button onClick={() => handleDelete(card.id)} style={{ color: "red" }}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>  
    </div>
  );
};

export default GiftCardAdd;
